const placeholderLocales = {
    en: 'Select Date',
    'zh-hant': '選擇日期',
    'zh-cn': '选择日期',
    vi: 'Chọn ngày',
    th: 'เลือกวันที่',
};
const placeholdersLocales = {
    en: ['Date From', 'To'],
    'zh-hant': ['日期從', '到'],
    'zh-cn': ['日期从', '到'],
    vi: ['Từ ngày', 'Tới ngày'],
    th: ['วันที่จาก', 'ถึง'],
};
const inputTooltipLocales = {
    en: 'Enter Format {{format}}',
    'zh-hant': '輸入格式 {{format}}',
    'zh-cn': '输入格式 {{format}}',
    vi: 'Nhập vào định dạng {{format}}',
    th: 'รูปแบบอินพุต {{format}}',
};
const clearTooltipLocales = {
    en: 'Clear',
    'zh-hant': '清除',
    'zh-cn': '清除',
    vi: 'Xoá sạch',
    th: 'ล้าง',
};
export const getDefaultPlaceholder = (lang) => placeholderLocales[lang] || placeholderLocales.en;
export const getDefaultPlaceholders = (lang) => placeholdersLocales[lang] || placeholdersLocales.en;
export const getDefaultInputTooltip = (lang) => inputTooltipLocales[lang] || inputTooltipLocales.en;
export const getDefaultClearTooltip = (lang) => clearTooltipLocales[lang] || clearTooltipLocales.en;
export const getCalendarBottomPosition = ({ containerRef, titleRef, }) => {
    var _a, _b;
    const containerHeight = ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
    const titleHeight = ((_b = titleRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
    const distanceToInput = 8;
    return (containerHeight - titleHeight + distanceToInput) / 16;
};
export { default as DatePicker } from './DatePicker';
export { default as DateRangePicker } from './DateRangePicker';
//# sourceMappingURL=index.js.map